export default function clearString(value: string | null): string | null {
  if (value === null || typeof value === 'undefined') {
    return null
  }
  return String(value).replace(/\n/g, '').replace(/\r/g, '').trim() || null
}
